import { jsx as e } from "react/jsx-runtime";
import r from "./roche-overline.module.scss.js";
const t = ({ overlineText: o, slot: i }) => /* @__PURE__ */ e("div", { className: r.overline, slot: i, children: /* @__PURE__ */ e("p", { className: r.overline__text, children: o }) });
export {
  t as RocheUIOverline
};
